import Table from './Table';
import Column from './sugar/Column';
import ColumnGroup from './sugar/ColumnGroup';
import { INTERNAL_COL_DEFINE } from './utils/legacyUtil';
export { Column, ColumnGroup, INTERNAL_COL_DEFINE };
export default Table;